import { createRouter, createWebHistory } from 'vue-router';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';

import { appRoutes, getFlatRoutes } from './routes';
import { REDIRECT_MAIN, NOT_FOUND_ROUTE, FORBIDDEN_ROUTE } from './routes/base';
import { LOGIN_ROUTE_PATH } from './constants';
import createRouteGuard from './guard';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const flatRoutes = getFlatRoutes(appRoutes);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: () => {
        const userAgent = navigator.userAgent;
        const isMobile = /iphone|ipad|ipod|android/i.test(userAgent);
        return isMobile
          ? import('@/views/home/mobile/index.vue')
          : import('@/views/home/index.vue');
      },
      meta: {
        notAuth: true,
      },
    },
    {
      path: '/insight',
      component: () => {
        const userAgent = navigator.userAgent;
        const isMobile = /iphone|ipad|ipod|android/i.test(userAgent);
        return isMobile
          ? import('@/views/home/mobile/insight.vue')
          : import('@/views/home/insight.vue');
      },
      meta: {
        notAuth: true,
      },
    },

    {
      path: '/landing-page',
      component: () => import('@/views/landing-page/index.vue'),
      props: route => ({
        invitationCode: route.query.invitation_code,
        source: route.query.utm_source,
      }),
      meta: {
        notAuth: true,
      },
    },
    {
      path: '/osw',
      component: () => import('@/views/osw/index.vue'),
      props: route => ({
        invitationCode: route.query.invitation_code,
        source: route.query.utm_source,
      }),
      meta: {
        notAuth: true,
      },
    },
    {
      path: '/landing-page/insight',
      component: () => {
        const userAgent = navigator.userAgent;
        const isMobile = /iphone|ipad|ipod|android/i.test(userAgent);
        return isMobile
          ? import('@/views/home/mobile/insight.vue')
          : import('@/views/home/insight.vue');
      },
      props: {
        pageType: 'landing-page',
      },
      meta: {
        notAuth: true,
      },
    },
    {
      path: '/landing-page/insight/detail',
      component: () => import('@/views/landing-page/detail/index.vue'),
      props: route => ({
        platform: route.query.platform,
        topic: route.query.topic,
      }),
      meta: {
        notAuth: true,
      },
    },
    {
      path: '/landing-page/insight/detail/callback/atomgit',
      component: () => import('@/views/landing-page/detail/callback-atomgit.vue'),
      props: route => ({
        platform: route.query.platform,
        code: route.query.code,
      }),
      meta: {
        notAuth: true,
      },
    },
    {
      path: '/landing-page/insight/detail/callback/third-party',
      component: () => import('@/views/landing-page/detail/callback-third-party.vue'),
      props: route => ({
        platform: route.query.oauth_platform,
        redirectUrl: route.query.oauth_redirect_uri,
        code: route.query.code,
      }),
      meta: {
        notAuth: true,
      },
    },

    {
      path: '/bind-account',
      component: () => import('@/views/user-details/callback.vue'),
      meta: {
        notAuth: true,
      },
    },

    {
      path: '/collect/:id',
      component: () => import('@/views/collect-page/index.vue'),
      props: true,
      meta: {
        notAuth: true,
      },
    },

    {
      path: '/collect/callback',
      component: () => import('@/views/collect-page/callback.vue'),
      props: route => ({
        code: route.query.code,
        from: route.query.from,
      }),
      meta: {
        notAuth: true,
      },
    },

    {
      path: LOGIN_ROUTE_PATH,
      component: () => import('@/views/login/index.vue'),
      props: route => ({
        code: route.query.code,
        from: route.query.from,
      }),
      meta: {
        notAuth: true,
      },
    },

    ...flatRoutes,
    REDIRECT_MAIN,
    FORBIDDEN_ROUTE,
    NOT_FOUND_ROUTE,
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            el: to.hash,
            behavior: 'smooth',
          });
        }, 50);
      })
    }
    else {
      return { top: 0 };
    }
  },
});

createRouteGuard(router);

export default router;
